<template>
  <div>
    <Header/>
    <section class="main" >
      <div class="container" v-if="!loader_token" v-loading="loader_token">
        <div class="main__header">
          <div class="main__currency">
            &euro;
          </div>
          <h1 class="main__title">
            Token explorer
          </h1>
          <button class="main__button">
            Buy
          </button>
        </div>
        <div class="token-info">
          <div class="token-info__item info">
            <div class="info__name">
              Address
            </div>
            <div class="info__value">
              <div class="info__value-purse purse">
                <a class="purse__link" href="#">{{$route.params.hash}}</a>
              </div>
              <div class="info__value-copy copy">
                <a
                  v-clipboard:success="copy_success"
                  v-clipboard="() => $route.params.hash"
                  class="copy__link">
                  <ion-icon name="copy" class="copy"></ion-icon>
                </a>
              </div>
            </div>
            <div class="info__name">
              Public key
            </div>
            <div class="info__value">
              <p>{{user.publicKey}}</p>
              <div class="info__value-copy copy">
                <a
                  v-clipboard:success="copy_success"
                  v-clipboard="() => user.publicKey"
                  class="copy__link">
                  <ion-icon name="copy" class="copy"></ion-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="token-info__item">
            <div class="info__name">
              Owned tokens
            </div>
            <dl class="info__list">
              <div v-for="table in tableData">
                <dt class="info__termin">
                  <router-link :to="'/transactions/' + table.mosaic + '/tx/1'">{{table.mosaic}}
                  </router-link>
                </dt>
                <dd class="info__definition">
                  {{table.quantity}}</dd>
              </div>
            </dl>
          </div>
        </div>
        <TableMosaicTransactions v-if="!updatedFlag" :loader_parent="loader_token"/>
      </div>
    </section>
    <Footer/>

  </div>
</template>

<script>
  import Header from '../components/Header';
  import TableTransactions from '../components/TableTransactions';
  import NamespaceProxy from '../../proxies/NamespaceProxy';
  import { divisibility } from '../../utils/Math_util';
  import search from './../../assets/images/icon/search.svg'
  import TableMosaicTransactions from '../components/TableMosaicTransactions';
  import { copy_success } from '../../utils/copy';

  export default {
    name: 'AccountDetail',
    components: {
      TableMosaicTransactions,
      TableTransactions,
      Header
    },
    async mounted() {
      this.load_tokens();
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
      async load_tokens() {
        this.tableData = [];
        this.loader_token = true;
        const namespace_proxy = new NamespaceProxy();
        this.user = await namespace_proxy.get_detail(this.$route.params.hash);

        const namespaces = await namespace_proxy.list_address_mosaic({ address: this.$route.params.hash });
        namespaces.map((namespace) => {
          if (namespace.namespace === 'arus') {
            this.tableData.push({
              ...namespace,
              quantity: divisibility(namespace.quantity, namespace.div)
            });
          }
        });
        this.loader_token = false;
      }
    },
    watch: {
      async '$route'(to, from) {
        if (to.params.hash !== from.params.hash) {
          this.updatedFlag = true;
          setTimeout(() => this.updatedFlag = false, 30);
          await this.load_tokens();
        }
      }
    },
    data: function () {
      return {
        updatedFlag: false,
        user: {},
        tableData: [],
        loader_token: true,
        search,
        copy_success
      };
    }
  };
</script>

<style scoped lang="scss">
  .info-address {
    margin-top: 40px;
    border-bottom: 1px solid #222;
    padding-bottom: 6px;

    h4 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
      margin-top: 6px;
    }
  }

  .table-owned {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .owned-container {
    margin-top: 20px;
  }

  .currency-container {
    display: flex;
    margin-bottom: 5px;

    .text-white {
      margin-left: 5px;
    }
  }

  .owned-title {
    margin-bottom: 5px;
    display: block;
  }

  .divider {
    margin-bottom: 20px;
  }

  .overflow {
    padding-top: 20px;
  }
</style>
